export enum CapsuleEventType {
  NEW = 'NEW',
  BECAME_CERTAIN = 'BECAME_CERTAIN',
  EXTINCT = 'EXTINCT',
}

export enum ColumnType {
  Reference = 'reference',
  Uuid = 'uuid',
  ConditionId = 'condition_id',
  Numeric = 'numeric',
  DateTime = 'datetime',
  Structured = 'structured',
}
